import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Category } from '@/__generated_graphql__/graphql';
import { SubFooterLink } from '@/components/ui/SubFooterLink/SubFooterLink';
import { useNavigate } from '@/hooks/useNavigate';
import { useSearchRoute } from '@/hooks/useSearchRoute';
import { useParticipant } from '@/providers/ParticipantProvider';

import * as S from './SubFooter.styles';

type SubFooterProps = {
  categories: Category[];
};

export const SubFooter: FC<SubFooterProps> = ({ categories }) => {
  const { t } = useTranslation();
  const { participant } = useParticipant();
  const { navigate } = useNavigate();

  const SEARCH = useSearchRoute();

  const participantLower = participant.toLowerCase();

  return (
    <S.Wrapper>
      <S.SubFooterTitle>
        {t(`SubFooter.title_${participantLower}`)}
      </S.SubFooterTitle>

      <S.Section>
        {categories.map(({ id, name, children }) => (
          <S.NavigationItem key={id}>
            <S.NavigationTitle>{name}</S.NavigationTitle>
            {children.map(({ name: childrenName, id: childrenId }) => {
              const path = navigate({
                link: true,
                route: SEARCH,
                participant,
                params: { categoryIds: childrenId }
              }) as string;

              return (
                <SubFooterLink
                  key={childrenId}
                  name={childrenName}
                  path={path}
                />
              );
            })}
          </S.NavigationItem>
        ))}
      </S.Section>
    </S.Wrapper>
  );
};
